/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */


var swicher_on_loop = document.getElementsByClassName("single_swicher_on_loop");

var Function_on_loop = function() {
    var attribute_img = this.getAttribute("data-img");
    var attribute_url = this.getAttribute("data-url");  
    var img_to_replace = this.parentElement.parentElement.previousSibling.childNodes[2].childNodes[0];
    this.parentElement.parentElement.previousSibling.classList.add("img_replace");
  	this.classList.add("active");  
    this.parentElement.parentElement.previousSibling.href=attribute_url;
	img_to_replace.srcset=attribute_img;
    this.parentElement.nextSibling.nextSibling.childNodes[0].nextSibling.href=attribute_url;
	console.log(this.parentElement.nextSibling.nextSibling.childNodes[0].nextSibling);
};

for (var i = 0; i < swicher_on_loop.length; i++) {
    swicher_on_loop[i].addEventListener('click', Function_on_loop, false);
}

var swicher_on_product = document.getElementsByClassName("single_swicher_on_product");

var Function_on_product = function() {
    var attribute_url = this.getAttribute("data-url");  
	window.location.href=attribute_url;
};

for (var i = 0; i < swicher_on_product.length; i++) {
    swicher_on_product[i].addEventListener('click', Function_on_product, false);
}


var custom_modal_size = document.getElementById("custom_modal_size");

var modal_on_open = function() {
  custom_modal_size.classList.add("active");
};

var modal_close = function() {
  custom_modal_size.classList.remove("active");
};

var custom_modal_feedaty = document.getElementById("custom_modal_feedaty");

var modal_on_open_feedaty = function() {
  custom_modal_feedaty.classList.add("active");
};

var modal_close_feedaty = function() {
  custom_modal_feedaty.classList.remove("active");
};


$( document ).ready(function() {

$(".btn_trigger_modal").on("click", function(){
  var tabella_misure = $(this).data("misure");
  console.log(tabella_misure);
  if(tabella_misure == "X"){
    $(".custom_modal_size img").attr("src","https://cdn.shopify.com/s/files/1/2355/8517/files/Tabella_X.jpg");      
  } else if(tabella_misure == "W"){
    $(".custom_modal_size img").attr("src","https://cdn.shopify.com/s/files/1/2355/8517/files/TABELLA_W..jpg");      
  } else if(tabella_misure == "Z"){
    $(".custom_modal_size img").attr("src","https://cdn.shopify.com/s/files/1/2355/8517/files/Tabella_Z_new.jpg");      
  } else if(tabella_misure == "A1"){
    $(".custom_modal_size img").attr("src","https://cdn.shopify.com/s/files/1/2355/8517/files/Tabella_A1.jpg");      
  } else if(tabella_misure == "Y"){
    $(".custom_modal_size img").attr("src","https://cdn.shopify.com/s/files/1/2355/8517/files/Tabella_Y_new.jpg");      
  } else if(tabella_misure == "A2"){
    $(".custom_modal_size img").attr("src","https://cdn.shopify.com/s/files/1/2355/8517/files/A2_CHW23GB_012.jpg");      
  } else if(tabella_misure == "A3"){
    $(".custom_modal_size img").attr("src","https://cdn.shopify.com/s/files/1/2355/8517/files/A3_CHW23VR_013.jpg");      
  } else if(tabella_misure == "A4"){
    $(".custom_modal_size img").attr("src","https://cdn.shopify.com/s/files/1/2355/8517/files/A4_CHW23DE_009.jpg");      
  } else if(tabella_misure == "A5"){
    $(".custom_modal_size img").attr("src","https://cdn.shopify.com/s/files/1/2355/8517/files/A5_CHW23PT_015.jpg");      
  } else if(tabella_misure == "A6"){
    $(".custom_modal_size img").attr("src","https://cdn.shopify.com/s/files/1/2355/8517/files/tabella_A6.png");       
  } else if(tabella_misure == "TEX"){
    $(".custom_modal_size img").attr("src","https://cdn.shopify.com/s/files/1/2355/8517/files/Camicia_TEX.jpg");      
  }else{
    $(".custom_modal_size img").attr("src","https://cdn.shopify.com/s/files/1/2355/8517/files/"+tabella_misure+".jpg");  
  }
  
});
  
  $(".ProductItem__ImageWrapper").each(function(index,value){
    //console.log($(value).attr("href"));
    var url_from_a = $(value).attr("href").split("/")
    var lunghezza = url_from_a.length;
    var nome_prodotto = url_from_a[lunghezza-1];
    //console.log(nome_prodotto);
    var switcher_color = $(".single_swicher[data-url='https://www.lirecento.it/products/"+nome_prodotto+"']");
    //console.log($(value).next().find(switcher_color));
    $(value).next().find(switcher_color).addClass("active").siblings().removeClass("active");
  });
  $(".single_swicher").on("click", function(){
    $(this).addClass("active").siblings().removeClass("active");
  });
  $(".heading_mobile_menu").on("click", function(){
    if($(this).hasClass("active")){
      $(this).removeClass("active");	
      $(this).next().removeClass("active");    
    }else{
      $(this).addClass("active");	
      $(this).next().addClass("active");    
    }
  });
  if (window.location.href.indexOf('#newMenu') != -1) {
        $('.MegaMenu').addClass('NewMegaMenu');
    }
  if (window.location.href.indexOf('#newMenuImg') != -1) {
        $('.MegaMenu').addClass('NewMegaMenu').addClass('NewMegaMenuImg');
    }
  if (window.location.href.indexOf('#newMenuMobile') != -1) {
        $('#sidebar-menu').addClass('NewMegaMobile');
    }
  var url_page_filter =  window.location.href;
  //console.log(url_page_filter);
  
  var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return typeof sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};

var value_filtered = getUrlParameter('sort_by');

  console.log(value_filtered);
  
  if(value_filtered){
    $("#shopify-section-collection-template").addClass('page_filtered');
  }

  //page_filtered

  /* NEWSLETTER CHECK PRIVACY START */
  $(".Footer__Newsletter.Form button").prop('disabled', true);
  $(".Footer__Newsletter .custom-checkbox").on("click", function(){
    if($('.Footer__Newsletter input.custom-control-input').is(':checked')) {
      $(".Footer__Newsletter.Form button").prop('disabled', false);
    }else{
      $(".Footer__Newsletter.Form button").prop('disabled', true);      
    }
  });
  /* NEWSLETTER CHECK PRIVACY END */  
  /* MODAL FEEDATY START */
$( "body" ).delegate( ".open_modal_feedaty", "click", function() {
  $("#custom_modal_feedaty").addClass("active");
});
$( "body" ).delegate( ".wrap_modal_info_feedaty", "click", function() {
  $("#custom_modal_feedaty").removeClass("active");
});

  
  
  /* MODAL FEEDATY END */

  
});

$(window).scroll(function() {    
    var scroll = $(window).scrollTop();
    var pageHeight = $(document).height() - 1200;
    //var anchorPoint = $("#shopify-section-footer").offset().top;
    //var pageHeight = $(document).height() - anchorPoint;
  
     //>=, not <=
    if (scroll >= 1000 && scroll <= pageHeight) {
        $(".CollectionToolbar").addClass("active");
    }else{
        $(".CollectionToolbar").removeClass("active");
    }
  
  

}); //missing );


var trigger_modal_size = document.getElementById("btn_trigger_modal");
    trigger_modal_size.addEventListener('click', modal_on_open, false);
 
    custom_modal_size.addEventListener('click', modal_close, false);



$(".Popover__Content .Popover__Value").on("click" , function(){
  console.log("click on value");
  setTimeout(function() {
      var isDisabled = $('.ProductForm__AddToCart').prop('disabled');
      if(isDisabled){
        console.log("disable");
        $('.wrap_message_out').append("<div class='message_out'><h2>Esaurito nel nostro shop online</h2><br><p>Il prodotto potrebbe essere disponibile nei nostri stores. Contattaci via <b><a href='https://api.whatsapp.com/message/RAVJ7GOFKI4VM1'>WhatsApp</a></b> oppure via <b><a href='mailto:info@lirecento.it'>e-mail</a></b> per verificare la disponibilità in tempo reale.</p></div>")
      } else{
         console.log("enable");
        $('.message_out').remove();
      }    
  }, 500);
});
